import type { TOC } from '@ember/component/template-only'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { not } from 'ember-truth-helpers'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import { ChartsCourseProgressAverages } from 'district-ui-client/components/charts/course-progress/averages/component'
import type ReSpellingProgressAveragesRoute from 'district-ui-client/reporting/ui-scope/re/spelling-progress/averages/route'
import { Precinct } from 'district-ui-client/domain/precinct'

interface Signature {
  Args: {
    model: ModelFor<ReSpellingProgressAveragesRoute>
  }
}

export const ReportingReSpellingProgressAveragesRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.spellingProgressAverages}}>
    {{#each @model.spellingProgressAverages as |gradeData|}}
      <div class="detailed-chart-wrapper">
        <ChartsCourseProgressAverages
          class="h-full"
          @data={{gradeData}}
          @precinct={{Precinct.RE_SPELLING}}
          @tooltip={{t "reporting.tooltips.spellingProgressAverages"}}
          @title={{t "reporting.chartTitles.spellingProgressAverages"}}
        />
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(ReportingReSpellingProgressAveragesRouteTemplate)
